import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RaioXDealer } from '../../../components/raio-x-dealer/raio-x-dealer';

@Component({
  selector: 'app-reports-dealer',
  standalone: true,
  imports: [
    CommonModule,
    RaioXDealer
  ],
  templateUrl: './dealer.html',
  styleUrls: ['./dealer.scss']
})
export class ReportsDealer {
}

